module.exports = __webpack_public_path__ + "img/cityPartnerLogo.dd8163f8.png";